<template>
<div>
    <!-- 展覽主視覺輪播 -->
    <div class="slides_topBanner mt-4">
        <carousel :perPage="1" :autoplay="true" :autoplayTimeout="3000" :loop="true" :paginationActiveColor="'#0689e6'" :paginationSize="13">
          <slide v-for="item in topbanner_list" :key="item.id">
            <div class="banner_item">
              <img :src="item.topbanner_url" alt="" title="" class="img-fluid" />
            </div>
          </slide>
        </carousel>
    </div><!-- //展覽主視覺輪播 -->
    
    <div class="container-fluid mb-5 position-relative ">  
      <!-- 關於我們 -->
      <div class="div_bottom_shadow">
        <div class="container py-4">
          <div class="index_topic_blcok">
            <div class="topic_border">
              <p class="topic_eng">ABOUT US</p>
              <p class="topic_cht">關於我們</p>
            </div>
          </div>

          <div class="row justify-content-center">
              <div class="col-4 col-md-2 p-4" style=" text-align:center;" v-for="item in about_list" :key="item.id">
                <img :src="item.about_img_url" alt="" title="" class="img-fluid" />
                <p class="py-2" v-html="item.about_content"></p>
              </div>
          </div>
        </div>
      </div><!-- //關於我們 -->

       <!-- 照片輪播 -->
      <div class="container-fluid slides_photo my-4 py-4 ">
        <carousel :perPage="1" :perPageCustom="[[768, 2], [1024, 3]]" :autoplay="true" :autoplayTimeout="3000" :loop="true" :paginationEnabled="false">
          <slide v-for="item in photourl_list" :key="item.id">
            <div class="photo_item">
              <img :src="item.url" alt="" title="" class="img-fluid" />
            </div>
          </slide>
        </carousel>
      </div><!-- //照片輪播 -->

      <!-- 展覽資訊 -->
      <div class="container index_exhibit_block divider-outside-aside py-5">
        <div class="index_topic_blcok">
          <div class="topic_border">
            <p class="topic_eng">EXHIBITION<br>INFORMATION</p>
            <p class="topic_cht">展覽資訊</p>
          </div>
        </div>

        <div class="row exhibit_list p-0 py-4 p-sm-4 p-md-2 p-lg-3 p-xl-4">
          <div class="list_item col-12 col-md-6 p-3 pt-3 pt-md-5" v-for="item in exhibit_info_list" :key="item.id">
            <router-link :to="{name: 'exhibit_info'}" tag="a">
              <div class="card flex-row flex-nowrap border-0">
                <div class="item_img card-header border-0 bg-white col-4 col-sm-3 col-md-4 col-lg-3 p-0">
                  <div class="item_img_border">
                      <img :src="item.logo_img_url" alt="" class="img-fluid">
                  </div>
                </div>
                <div class="item_des card-block col-8 col-sm-9 col-md-8 col-lg-9 p-0 px-3 px-sm-3 p-xl-2 px-xl-3">
                  <h5 class="exhibit_title">{{item.exhibit_title}}</h5>
                  <p class="exhibit_content">{{item.exhibit_content}}</p>
                </div>
              </div>
            </router-link>
          </div>

        </div><!-- //exhibit_list -->

        <!-- 手機版摺疊panel --> 
        <div style="display:none;">
          <div id="accordion">
            <div>
              <div id="headingPanel" class="text-center">
                  <button class="btn btn-primary collapsed" data-toggle="collapse" data-target="#collapsePanel" aria-expanded="false" aria-controls="collapsePanel">
                    more
                  </button>
              </div>
              <div id="collapsePanel" class="collapse" aria-labelledby="headingPanel" data-parent="#accordion">
                <div class=" container collapse-body">
                最後六則exhibit block   
                </div>
              </div>
            </div>
          </div>
        </div><!-- //手機版摺疊panel -->
      </div><!-- //展覽資訊 -->

      <!-- 產業資訊 -->
      <div class="container index_news_block py-5">
        <div class="index_topic_blcok">
          <div class="topic_border">
            <p class="topic_eng">INDUSTRY<br>INFORMATION</p>
            <p class="topic_cht">產業資訊</p>
          </div>
        </div>
        <div class="news_list p-5">
          <ul class="">
            <li v-for="item in news_list" :key="item.id"><a :href="item.news_url">{{item.news_content}}</a></li>
          </ul>
        </div>
      </div><!-- //產業資訊 -->

      <!-- 合作單位 -->
      <div class="container">
        <div class="index_topic_blcok">
          <div class="topic_border">
            <p class="topic_eng">PARTNERS</p>
            <p class="topic_cht">合作單位</p>
          </div>
        </div>
        <div class="py-4">
          <carousel :perPageCustom="[[768, 2], [1024, 4]]" :autoplay="true" :autoplayTimeout="3000" :loop="true" :paginationEnabled="false" :navigationEnabled="true">
          <slide v-for="item in partner_list" :key="item.id">
            <div class="logo_item">
              <img :src="item.partner_img_url" alt="" title="" class="img-fluid" />
            </div>
          </slide>
        </carousel>
        </div> 
      </div><!-- //合作單位 -->

      <!-- welcome panel -->
      <div class="welcome_panel position-fixed" style="bottom:2%; right:1%;">
        <div class="card p-2" style="width: 250px;">
          <div class="card-body p-4">
            <div><img src="../assets/index/welcome.png" alt="" class="img-fluid"></div>
            <div class="d-flex py-2 justify-content-between" style="text-align:center;">
                <a href="#" class="btn btn-primary p-1 px-2" >我想參觀</a>
                <a href="#" class="btn btn-primary p-1 px-2" >我想逛展</a>
            </div>
          </div>
        </div>
      </div><!-- //welcome panel -->

    </div>

</div>
</template>

<script>
export default {
  data () {
    return {
      topbanner_list: [
        {topbanner_url: require('../assets/slides_banner/topbanner-00.jpg'), id: 'topbanner-00'},
        {topbanner_url: require('../assets/slides_banner/topbanner-01.jpg'), id: 'topbanner-01'},
        {topbanner_url: require('../assets/slides_banner/topbanner-02.jpg'), id: 'topbanner-02'},
        {topbanner_url: require('../assets/slides_banner/topbanner-03.jpg'), id: 'topbanner-03'},
        {topbanner_url: require('../assets/slides_banner/topbanner-04.jpg'), id: 'topbanner-04'},
        {topbanner_url: require('../assets/slides_banner/topbanner-05.jpg'), id: 'topbanner-05'},
        {topbanner_url: require('../assets/slides_banner/topbanner-06.jpg'), id: 'topbanner-06'},
        {topbanner_url: require('../assets/slides_banner/topbanner-07.jpg'), id: 'topbanner-07'},
        {topbanner_url: require('../assets/slides_banner/topbanner-08.jpg'), id: 'topbanner-08'}
      ],
      about_list: [
        {
          about_content: '國內/外展覽',
          about_img_url: require('../assets/index/about_logo01.png'),
          id: 'about_logo01'
        },
        {
          about_content: '議題操作<br>媒體公關操作',
          about_img_url: require('../assets/index/about_logo02.png'),
          id: 'about_logo02'
        },
        {
          about_content: '專業展覽顧問',
          about_img_url: require('../assets/index/about_logo03.png'),
          id: 'about_logo03'
        },
        {
          about_content: '整合行銷策略',
          about_img_url: require('../assets/index/about_logo04.png'),
          id: 'about_logo04'
        },
        {
          about_content: '國際策展交流',
          about_img_url: require('../assets/index/about_logo05.png'),
          id: 'about_logo05'
        }
      ],
      photourl_list: [
        {url: require('../assets/slides_photo/photo-01.jpg'), id: 'photo-01'},
        {url: require('../assets/slides_photo/photo-02.jpg'), id: 'photo-02'},
        {url: require('../assets/slides_photo/photo-03.jpg'), id: 'photo-03'},
        {url: require('../assets/slides_photo/photo-04.jpg'), id: 'photo-04'}
      ],
      exhibit_info_list: [
        {
          exhibit_title: '2018素食展',
          exhibit_content: '享用蔬食，不只就地球還能更健康！遵守【蔬果579】的概念享用蔬食，不只就地球還能更健康！遵守【蔬果579】的概念',
          logo_img_url: require('../assets/exhibit_logo/exhibit_logo_01.png'),
          id: 'exhibit_logo_01'
        },
        {
          exhibit_title: '2018婚紗展',
          exhibit_content: '全國最大規模台北國際婚紗展，將於2018年6月22日~25日全國最大規模台北國際婚紗展，將於2018年6月22日~25日',
          logo_img_url: require('../assets/exhibit_logo/exhibit_logo_02.png'),
          id: 'exhibit_logo_02'
        },
        {
          exhibit_title: '2018全省婦幼展',
          exhibit_content: '專門為懷孕媽咪、迎接新生兒家庭量身打造的台南嬰兒與孕媽咪用品展專門為懷孕媽咪、迎接新生兒家庭量身打造',
          logo_img_url: require('../assets/exhibit_logo/exhibit_logo_03.png'),
          id: 'exhibit_logo_03'
        },
        {
          exhibit_title: '2018佛事用品暨雕刻藝品展',
          exhibit_content: '佛教對華人文化的發展影響歐2000餘年，藉由信仰及傳承，佛事文物、雕刻佛教對華人文化的發展影響歐2000餘年，藉由信仰及傳承',
          logo_img_url: require('../assets/exhibit_logo/exhibit_logo_04.png'),
          id: 'exhibit_logo_04'
        },
        {
          exhibit_title: '2018美食辦手禮展',
          exhibit_content: '台灣國際美食暨伴手禮8/24-27世貿一館盛大登場。六大特色主題館台灣國際美食暨伴手禮8/24-27世貿一館盛大登場。',
          logo_img_url: require('../assets/exhibit_logo/exhibit_logo_05.png'),
          id: 'exhibit_logo_05'
        },
        {
          exhibit_title: '2018台灣國際創意文具展',
          exhibit_content: '「2018台灣國際創意文具展暨第16屆台灣文具展示會」於7/6-9於世貿一館展出。「2018台灣國際創意文具展暨第16屆台灣文具展示會」',
          logo_img_url: require('../assets/exhibit_logo/exhibit_logo_06.png'),
          id: 'exhibit_logo_06'
        },
        {
          exhibit_title: '上聯寵物用品博覽會',
          exhibit_content: '寵物用品博覽會會及全台各大寵物用品廠商，提供最新寵物用品、飼料零食寵物用品博覽會會及全台各大寵物用品廠商',
          logo_img_url: require('../assets/exhibit_logo/exhibit_logo_07.png'),
          id: 'exhibit_logo_07'
        },
        {
          exhibit_title: '2018智慧生活軟體應用展',
          exhibit_content: '在智慧時代競爭白熱化的驅動下，全球軟實力時序優化創新，所有產業在智慧時代競爭白熱化的驅動下，全球軟實力時序優化創新',
          logo_img_url: require('../assets/exhibit_logo/exhibit_logo_08.png'),
          id: 'exhibit_logo_08'
        },
        {
          exhibit_title: '2018酒展',
          exhibit_content: '2017年上聯國際展覽公司舉辦「2017台北國際精緻酒展」，在酒業界2017年上聯國際展覽公司舉辦「2017台北國際精緻酒展」',
          logo_img_url: require('../assets/exhibit_logo/exhibit_logo_09.png'),
          id: 'exhibit_logo_09'
        },
        {
          exhibit_title: '2018婚紗展',
          exhibit_content: '「2017台北美容美體保養品暨韓國美容展」將於8/24-27在台北世貿一館「2017台北美容美體保養品暨韓國美容展」',
          logo_img_url: require('../assets/exhibit_logo/exhibit_logo_10.png'),
          id: 'exhibit_logo_10'
        },
        {
          exhibit_title: '2019台北汽機車零配件暨改裝套件展',
          exhibit_content: '車市創十幾年來銷售新高佳績，新車市場相對應推出新款車型車市創十幾年來銷售新高佳績，新車市場相對應推出新款車型',
          logo_img_url: require('../assets/exhibit_logo/exhibit_logo_11.png'),
          id: 'exhibit_logo_11'
        },
        {
          exhibit_title: '2018 地方旅展',
          exhibit_content: '臺灣擁有豐富的旅遊資源及熱愛旅遊的民眾，據交通部觀光局統計105年臺灣臺灣擁有豐富的旅遊資源及熱愛旅遊的民眾',
          logo_img_url: require('../assets/exhibit_logo/exhibit_logo_12.png'),
          id: 'exhibit_logo_12'
        }
      ],
      news_list: [
        {
          news_url: '',
          news_content: '2018-02-21 倒數5天!眾所期待的【台中婦幼展】即將於3/2-5大台中國際會展中心與大家見面!!別等了 直接索票吧!',
          id: 'news01'
        },
        {
          news_url: '',
          news_content: '2018-02-12 夏季最大旅展5/4-7世貿一館 送限量免費門票吃喝玩樂攏底佳!',
          id: 'news02'
        },
        {
          news_url: '',
          news_content: '2018-02-07 預約看展=>【100台電視天天抽】2018台北電器空調3C影音大展',
          id: 'news03'
        },
        {
          news_url: '',
          news_content: '2018-02-01 春季強檔-上聯寵物用品博覽會4/5-4/8連假就來世貿三館，免費寵物好禮拿不完!',
          id: 'news04'
        },
        {
          news_url: '',
          news_content: '2018-01-26 台北國際連鎖加盟大展3/1-3/4【搶免費門票】世貿一館盛大登場!',
          id: 'news05'
        },
        {
          news_url: '',
          news_content: '2018-01-24 日本主題館首度登場4/5-8世貿一館【搶0元食品展門票】',
          id: 'news06'
        },
        {
          news_url: '',
          news_content: '2018-01-24 搶先預約=>送超可愛夢幻好禮3/1-4台北國際家具展',
          id: 'news07'
        },
        {
          news_url: '',
          news_content: '2018-02-21 倒數5天!眾所期待的【台中婦幼展】即將於3/2-5大台中國際會展中心與大家見面!!別等了 直接索票吧!',
          id: 'news08'
        }
      ],
      partner_list: [
        {
          partner_name: '',
          partner_img_url: 'https://dykt84bvm7etr.cloudfront.net/uploadfiles/672/shop_logo/6324.png',
          id: 'shop_logo01'
        },
        {
          partner_name: '',
          partner_img_url: 'https://dykt84bvm7etr.cloudfront.net/uploadfiles/672/shop_logo/5872.png',
          id: 'shop_logo02'
        },
        {
          partner_name: '',
          partner_img_url: 'https://dykt84bvm7etr.cloudfront.net/uploadfiles/672/shop_logo/5916.png',
          id: 'shop_logo03'
        },
        {
          partner_name: '',
          partner_img_url: 'https://dykt84bvm7etr.cloudfront.net/uploadfiles/672/shop_logo/5873.png',
          id: 'shop_logo04'
        },
        {
          partner_name: '',
          partner_img_url: 'https://dykt84bvm7etr.cloudfront.net/uploadfiles/672/shop_logo/5877.png',
          id: 'shop_logo05'
        },
        {
          partner_name: '',
          partner_img_url: 'https://dykt84bvm7etr.cloudfront.net/uploadfiles/672/shop_logo/5914.png',
          id: 'shop_logo06'
        }
      ]
    }
  },
  mounted() {
    $(function(){
      // 切換nav_menu
      var nav_menu = $('.nav-menu');
      var footer = $('footer');
      nav_menu.eq(1).hide();
      nav_menu.eq(0).show();
      footer.eq(1).hide();
      footer.eq(0).show();
      $('#topSearchBox').show();
      $('#lang_chi').text('中');
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/**index_topic**/
.index_topic_blcok .topic_border { 
  padding: 0px 0 1px 1.6rem;
  border-left:1px solid #d6d6d6; 
  font-size:2rem; 
  line-height:1;
}
.index_topic_blcok .topic_border .topic_eng { 
  color:#8c8c8d;
  line-height:1.1;
}
.index_topic_blcok .topic_border .topic_cht { 
  color:#b0b0b0;
  letter-spacing: 9px;
}

/**index shadow**/
.div_bottom_shadow {
  position:relative;
  background-color: #fff;
}
.div_bottom_shadow:before {
  content: ""; 
  position:absolute; 
  z-index: -1; 
  width:90%;  
  bottom: 0; 
  height: 10px; 
  left: 5%; 
  border-radius: 100px / 5px; -moz-border-radius: 100px / 5px; -webkit-border-radius: 100px / 5px; 
  box-shadow:0 0 30px rgba(0,0,0,0.2); -moz-box-shadow:0 0 30px rgba(0,0,0,0.2); -webkit-box-shadow:0 0 30px rgba(0,0,0,0.2); 
}

/**照片輪播**/
.photo_item{ 
  padding: 1%;
}

/**展覽資訊**/
.index_exhibit_block{
  background-color:#fff;
}
.divider-outside-aside {
  position:relative;
}
.divider-outside-aside:before {
  content: "";
  position: absolute;
  z-index: -1;
  width: 98.5%;
  height: 90%;
  top: 4%;
  margin: 0 auto;
  border-radius: 10%;
  -webkit-box-shadow: 0 0 40px rgba(0,0,0,0.4);
  box-shadow: -5px 0 40px rgba(0,0,0,0.4);
}
@media (max-width: 992px){
  .divider-outside-aside:before {
    border-radius: 5%;
    width: 97.8%;
  }
}
@media (max-width: 768px){
  .divider-outside-aside:before {
    border-radius: 0%;
    width: 95.5%;
    box-shadow: -6px 0 30px rgba(0,0,0,0.4);
  }
}

.list_item{
  border-bottom :1px solid rgba(0, 0, 0, 0.2);;
}
.list_item a { color:#3f3f3f;}
.list_item a:hover { text-decoration: none;}
.list_item a:hover .exhibit_title { color:#007bff;}
.item_img_border { border:1px solid rgba(0, 0, 0, 0.2); padding:5px; border-radius: 2px; box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.3);}
.exhibit_title { height:3.5rem; overflow: hidden; font-weight:500;}
@media (max-width: 576px){
  .exhibit_title { height: 3rem;}  
}
.exhibit_content { 
    font-size: 1rem; display: block; display: -webkit-box;
    -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; text-overflow: ellipsis; text-align: justify; 
}

/**產業資訊**/
.news_list ul { list-style-type: disc;  }
.news_list ul li { line-height:2; overflow : hidden; text-overflow : ellipsis; white-space : nowrap; width:auto; }

/**合作單位**/
.logo_item { text-align: center; border:1px solid rgba(0, 0, 0, 0.2); margin: 3%;}
.logo_item img { height:100px;}

/**welcome panel**/
@media (max-width: 768px){
  .welcome_panel { display: none;}

}

</style>



// WEBPACK FOOTER //
// src/components/home.vue